import moment from 'moment';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { StoreState } from '..';
import errorHandler from '../../errorHandler';
import apiRest from '../../services/apiRest';
import FormPeople from '../../types/FormPeople';
import { addSnackbar } from '../snacks/snacksActions';
import { PeopleAction, PeopleActionTypes } from './peopleTypes';

export function getPeople():
  ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState;
      const { status, gender, under_age } = getState().peopleState.filters;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({
        type: PeopleActionTypes.GET_PEOPLE_START,
      });
      const { data } = await apiRest({
        method: 'get',
        url: `/people/`,
        params: {
          churchId,
          status,
          gender,
          under_age,
        },
      });
      dispatch({
        type: PeopleActionTypes.GET_PEOPLE_SUCCESS,
        people: data,
      });
    } catch (e) {
      errorHandler(e);
      dispatch(addSnackbar('Houve um problema. Tente mais tarde.', { variant: 'error' }));
      dispatch({ type: PeopleActionTypes.GET_PEOPLE_ERROR });
    }
  };
}

export function savePerson(form: FormPeople):
  ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { people, selectedIndex } = getState().peopleState;
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }

      dispatch({ type: PeopleActionTypes.SAVE_PERSON_START });

      const personOrig = selectedIndex !== null && people[selectedIndex];

      /**
       * Upload da foto
       */
      let imageId = personOrig.imageId;
      if (form.image instanceof File) {
        const formData = new FormData();
        formData.append('image', form.image);
        const { data } = await apiRest({
          method: 'POST',
          url: `/uploads/image/`,
          params: { churchId },
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        imageId = data.id;
      } else if (!form.image) {
        imageId = null;
      }

      delete form.image;
      await apiRest({
        method: personOrig ? 'PUT' : 'POST',
        url: `/people/${personOrig ? personOrig.id : ''}`,
        params: { churchId },
        data: {
          ...form,
          imageId,
          address: {
            ...form.address,
            number: parseInt(form.address.number, 10) || null,
          },
          childrenQty: parseInt(form.childrenQty, 10) || 0,
          hadMembershipCard: form.hadMembershipCard === 'Sim',
          birthday: form.birthday ? moment(form.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
          membershipCardDate: form.membershipCardDate ? moment(form.membershipCardDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
          weddingDate: form.weddingDate ? moment(form.weddingDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
          consecratedDate: form.consecratedDate ? moment(form.consecratedDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
          baptismDate: form.baptismDate ? moment(form.baptismDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
          ministryDate: form.ministryDate ? moment(form.ministryDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        },
      });

      dispatch({ type: PeopleActionTypes.SAVE_PERSON_SUCCESS });
      dispatch(addSnackbar('Registro salvo com sucesso', { variant: 'success' }));
      dispatch(getPeople());
    } catch (e) {
      errorHandler(e);
      dispatch(addSnackbar('Houve um problema. Tente mais tarde.', { variant: 'error' }));
      dispatch({ type: PeopleActionTypes.SAVE_PERSON_ERROR });
    }
  };
}

export function removePerson():
  ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { selectedIndex, people } = getState().peopleState;
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({ type: PeopleActionTypes.REMOVE_PERSON_START });

      const personOrig = selectedIndex !== null && people[selectedIndex];
      if (!personOrig) {
        throw new Error();
      }

      const res = await apiRest({
        method: 'DELETE',
        url: `/people/${personOrig.id}`,
        params: { churchId },
        validateStatus: status => [200, 422].includes(status),
      });
      if (res.status === 422) {
        dispatch(addSnackbar('Não foi possível excluir pois este cadastro possui transações financeiras vinculadas.', { variant: 'error' }));
        dispatch({ type: PeopleActionTypes.REMOVE_PERSON_ERROR });
        return;
      }

      dispatch({ type: PeopleActionTypes.REMOVE_PERSON_SUCCESS });
      dispatch(addSnackbar('Registro removido com sucesso', { variant: 'success' }));
      dispatch(getPeople());
    } catch (e) {
      errorHandler(e);
      dispatch(addSnackbar('Houve um problema. Tente mais tarde.', { variant: 'error' }));
      dispatch({ type: PeopleActionTypes.REMOVE_PERSON_ERROR });
    }
  };
}

export function editingStart(selectedIndex?: number): PeopleAction {
  return {
    type: PeopleActionTypes.EDITING_START,
    index: selectedIndex,
  };
}

export function setFilters(status: string, gender: string, under_age: boolean): PeopleAction {
  return {
    type: PeopleActionTypes.SET_PEOPLE_FILTERS,
    filters: { status, gender, under_age },
  };
}
